import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatTableDataSource,
} from "@angular/material";
import { Component, Inject, OnInit } from "@angular/core";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { MedicalOrderService } from "src/app/services/medical-order.service";
import { MedicalOrderProcedureExtraction } from "src/app/model/medical-order-procedure-extraction/medical-order-procedure-extraction";
import { SelectionModel } from "@angular/cdk/collections";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { PracticeService } from "src/app/services/practice.service";
import { Observable } from "rxjs";
import { PracticeRegionSearchReservation } from "src/app/model/practice-region-reservation";
import { FormBuilder, FormGroup } from "@angular/forms";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-medical-order-procedure-extraction-dialog",
  templateUrl: "medical-order-procedure-extraction.component.html",
  styleUrls: ["./medical-order-procedure-extraction.component.css"],
})
export class MedicalOrderProcedureExtractionComponent implements OnInit {
  displayedColumns: string[] = ["select", "extracted"];

  noRecognizedProcedures: MedicalOrderProcedureExtraction[] = [];
  recognizedProcedures: MedicalOrderProcedureExtraction[] = [];
  noAgreementProcedures: MedicalOrderProcedureExtraction[] = [];
  sanitizedFileUrl: SafeResourceUrl;
  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<MedicalOrderProcedureExtraction>(true, []);

  procedures: PracticeRegionSearchReservation[] = [];
  filterCompletePosiblePractices: Observable<PracticeRegionSearchReservation[]>;

  info: any;
  loading: boolean = false;
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private practiceService: PracticeService,
    private sanitizer: DomSanitizer,
    private notificationToastService: NotificationToastService,
    private medicalOrderService: MedicalOrderService,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.formBuilder.group({
      Procedure: [null],
    });
    this.info = data;
  }

  async ngOnInit() {
    this.loading = true;

    this.procedures =
      await this.practiceService.getFilteredPracticeRegionSearchReservation(
        this.data.planId,
        this.data.physicianId,
        this.data.equipmentId,
        this.data.centerId
      );

    this.sanitizedFileUrl = this.getSanitizedFileUrl();

    this.filterCompletePosiblePractices =
      this.form.controls.Procedure.valueChanges.pipe(
        startWith<string | PracticeRegionSearchReservation>(""),
        map((value) =>
          typeof value === "string" ? value : value ? value.Name : ""
        ),
        map((name) => this.filterPosiblePractices(name))
      );

    this.form.controls.Procedure.valueChanges.subscribe((value) => {
      if (value && typeof value !== "string") {
        const exists = this.recognizedProcedures.find(
          (p) => p.PracticeRegion && p.PracticeRegion.Id === value.Id
        );

        if (!exists) {
          this.recognizedProcedures.unshift({
            ExtractedProcedure: value.Name,
            IsManualAdded: true,
            PracticeRegion: {
              Name: value.Name,
              Id: value.Id,
              PracticeId: value.Id,
            },
          });

          this.dataSource = new MatTableDataSource(this.recognizedProcedures);
          this.selection.select(this.recognizedProcedures[0]);
        }

        this.form.patchValue(
          {
            Procedure: [null],
          },
          { emitEvent: false }
        );
      }
    });

    await this.process();
  }

  public displayPosiblePracticesFn(
    item?: PracticeRegionSearchReservation
  ): string | undefined {
    return item ? item.Name : undefined;
  }

  filterPosiblePractices(
    seachText?: string
  ): PracticeRegionSearchReservation[] {
    return seachText
      ? this.procedures.filter(
          (option) =>
            option && this.coincideFilter(option, seachText.split(" "))
        )
      : this.procedures
      ? this.procedures.slice()
      : [];
  }

  coincideFilter(
    practiceRegionSearchReservation: PracticeRegionSearchReservation,
    filters: string[]
  ): boolean {
    let response = true;
    filters.forEach((filter) => {
      if (
        filters.length === 1 &&
        practiceRegionSearchReservation.Code &&
        practiceRegionSearchReservation.Code === filter
      ) {
        response = true;
      } else if (
        response &&
        practiceRegionSearchReservation.SeachText.toLowerCase().indexOf(
          filter.toLowerCase()
        ) < 0
      ) {
        response = false;
      }
    });

    return response;
  }

  // Zoom y rotación
  zoomLevel = 1;
  rotation = 0;

  // Pan con la mano
  isDragging = false;
  dragStartX = 0;
  dragStartY = 0;
  translateX = 0;
  translateY = 0;
  initialX = 0;
  initialY = 0;

  expandedRows = new Set<any>();

  toggleRow(proc: any) {
    if (this.expandedRows.has(proc)) {
      this.expandedRows.delete(proc);
    } else {
      this.expandedRows.add(proc);
    }
  }

  zoomIn() {
    this.zoomLevel = Math.min(this.zoomLevel + 0.1, 3);
  }
  zoomOut() {
    this.zoomLevel = Math.max(this.zoomLevel - 0.1, 0.1);
  }
  resetZoom() {
    this.zoomLevel = 1;
    this.rotation = 0;
    this.translateX = 0;
    this.translateY = 0;
  }
  rotate() {
    this.rotation = (this.rotation + 90) % 360;
  }

  onWheel(event: WheelEvent) {
    event.preventDefault();
    const delta = event.deltaY > 0 ? -0.1 : 0.1;
    this.zoomLevel = Math.max(0.1, Math.min(this.zoomLevel + delta, 3));
  }

  // Movimiento con la manito
  startDragging(event: MouseEvent) {
    this.isDragging = true;
    this.dragStartX = event.clientX;
    this.dragStartY = event.clientY;
    this.initialX = this.translateX;
    this.initialY = this.translateY;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging) return;
    const deltaX = event.clientX - this.dragStartX;
    const deltaY = event.clientY - this.dragStartY;
    this.translateX = this.initialX + deltaX;
    this.translateY = this.initialY + deltaY;
  }

  stopDragging() {
    this.isDragging = false;
  }

  isPdf(): boolean {
    if (!this.info || !this.info.fileBase64) {
      return false;
    }
    return this.info.fileBase64.startsWith("data:application/pdf");
  }

  getSanitizedFileUrl(): SafeResourceUrl {
    if (!this.info || !this.info.fileBase64) {
      return this.sanitizer.bypassSecurityTrustResourceUrl("");
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(this.info.fileBase64);
  }

  onNoClick($event): void {
    this.dialogRef.close();
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.recognizedProcedures.forEach((row) => this.selection.select(row));
  }

  isAllSelected() {
    if (this.selection.selected && this.recognizedProcedures) {
      const numSelected = this.selection.selected.length;
      const numRows = this.recognizedProcedures.length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  someSelected(): boolean {
    return this.selection.selected.length > 0;
  }

  finish() {
    this.dialogRef.close(this.selection.selected);
  }

  async process() {
    try {
      if (!this.data.service.canExtrarProceduresByIntents()) {
        this.notificationToastService.error(
          "No se puede realizar la operación",
          "Admisión"
        );
        return;
      }

      this.loading = true;
      const result = await this.medicalOrderService.extractProcedures(
        this.info.fileBase64,
        this.info.planId,
        this.info.centerId,
        this.info.physicianId,
        this.info.equipmentId
      );

      this.data.service.setExtractedProcedures();
      this.noRecognizedProcedures = result.NoRecognizedProcedures;
      this.recognizedProcedures = result.RecognizedProcedures;
      this.noAgreementProcedures = result.NoAgreementProcedures;

      this.dataSource = new MatTableDataSource(this.recognizedProcedures);
      this.selection = new SelectionModel<MedicalOrderProcedureExtraction>(
        true,
        this.recognizedProcedures
      );
    } catch (error) {
      console.error("Error extracting procedures:", error);
      this.notificationToastService.error(
        "Error al extraer las prácticas médicas.",
        "Error"
      );
    } finally {
      this.loading = false;
    }
  }
}
